// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2ij3E","list":"PatternAutocomplete_list__3XoDS"};